import { createFeatureSelector } from '@ngrx/store';

import { type WebsiteState, WEBSITE_FEATURE_KEY } from './website-feature.reducer';

export const websiteState = createFeatureSelector<WebsiteState>(WEBSITE_FEATURE_KEY);
